import "jquery-validation";
import 'jquery-validation/dist/localization/messages_es';
import './validators.js';
import "select2";
import "select2/dist/js/i18n/es.js";
const ExcelJS = require("exceljs");

var enerclub_core = (function ($) {
    var validation = {
        lang: 'es',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            error.addClass('invalid-feedback');
            $(element).parent().append(error);

        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid');
        },
        onfocusout: function (element) {
            this.element(element); // validate element immediately
        },
    }

    /**
     * metodo para mostrar capa cargando
     * @param {HTMLElement} el
     * @param {boolean} loading   
     * @param {string} css 
     * @param {string} text
     */
    var loading = function (el, loading = true, css = 'spinner-grow text-light', text = '...') {
        // disable button
        $(el).prop("disabled", loading);

        // add spinner to button
        // NOTA: necesario añadir position:relative al container padre para centrar el loading 
        $(el).find('[role=status]').remove();
        if (loading) {
            $(el).prepend($('<div class="d-flex justify-content-center align-items-center _loader"> <div class="' + css + '" role="status"><span class="visually-hidden">' + text + '</span></div></div>'));
        }
    }

    /**
     * obtener el mensaje de error de la respuesta del api
     * 
     * @typedef {Object} Enerclub_api_error
     * @property {string} code
     * @property {string} message
     * 
     * @param {jqXHR} jqXHR 
     * @returns {Enerclub_api_error}
     */
    var get_api_error = function (jqXHR) {
        var error = { code: 0, message: 'Se ha producido un error, inténtelo más adelante.' };
        try {
            if (jqXHR.responseJSON && jqXHR.responseJSON.code && jqXHR.responseJSON.message) {
                if (jqXHR.responseJSON.code === 'rest_invalid_param') {
                    var details = null;
                    if (jqXHR.responseJSON.data.details) {
                        details = Object.values(jqXHR.responseJSON.data.details)[0];
                    }
                    var detail_error = details.code && details.message ? details : jqXHR.responseJSON;
                    error = { code: detail_error.code, message: detail_error.message }
                } else {
                    error = { code: jqXHR.responseJSON.code, message: jqXHR.responseJSON.message }
                }
            }
        } catch (err) {
            error = { code: 0, message: 'Se ha producido un error, inténtelo más adelante.' };
        }

        return error;
    };

    /**
     * obtener el mensaje de error de la respuesta del api
     * @param {jqXHR} jqXHR 
     * @returns {string}
     */
    var get_api_error_message = function (jqXHR) {
        var error = get_api_error(jqXHR);
        return error.message;
    };

    /**
 * formatea el Excel generado
 * @param {worksheet} worksheet
 * @returns {worksheet}
 */
    var formatExcel = function (worksheet) {
        // - Header
        worksheet.getRow(1).alignment = {
            horizontal: "center",
            vertical: "center",
        };

        worksheet.getRow(1).eachCell(function (cell) {
            worksheet.getCell(cell.address).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '3f62fa' },
            };
        });

        worksheet.getRow(1).font = {
            color: { argb: "FFFFFF" },
            bold: true,
            size: 10,
        };


        return worksheet;
    };

    /**
     * genera el nombre del Excel que se exporta
     * @param {string} name 
     * @returns {string}
     */
    var getExcelName = function (name) {
        var now = new Date();
        var day = now.getDate();
        var month =
            now.getMonth() + 1 < 10 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
        var year = now.getFullYear();
        var time =
            (now.getHours() < 10
                ? "0" + now.getHours().toString()
                : now.getHours().toString()) +
            (now.getMinutes() < 10
                ? "0" + now.getMinutes().toString()
                : now.getMinutes().toString()) +
            (now.getSeconds() < 10
                ? "0" + now.getSeconds().toString()
                : now.getSeconds().toString());
        var excelName = name + '_' + year + month + day + time + ".xlsx";
        return excelName;
    };

    /**
     * exporta el Excel generado
     * @param {workbook} workbook
     * @param {string} excelName
     */
    var exportExcel = async function (workbook, excelName) {
        const buffer = await workbook.xlsx.writeBuffer();
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const blob = new Blob([buffer], { type: fileType });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", getExcelName(excelName));
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    /**
     * genera el excel
     * @param {Array} data 
     * @param {any} keys
     */
    var writeExcel = async function (data, keys) {
        var workbook = new ExcelJS.Workbook();
        var ws = workbook.addWorksheet(keys.title);

        // - rellenar Excel con los datos
        const elements = [];
        Object.entries(keys).forEach(([key, value]) => {
            if (key !== 'title') {
                elements.push({
                    header: value,
                    key: key,
                    width: 25,
                    style: { font: { size: 10 } },
                });
            }
        });
        ws.columns = elements.map((element) => {
            return {
                header: element.header,
                key: element.key,
                width: element.width,
                style: element.style,
            };
        });

        data.forEach((el) => {
            const row = {};
            Object.entries(el).forEach(([key, value]) => {
                // Si el valor es null o NULL, dejar la celda vacía
                row[key] = (value === null || value === "NULL") ? '' : value;
            });
            ws.addRow(row);
        });

        ws = formatExcel(ws);

        exportExcel(workbook, keys.title);
    };

    return {
        loading,
        writeExcel,
        validation,
        get_api_error_message
    }

})(jQuery);

global.enerclub_core = enerclub_core;
